import { render, staticRenderFns } from "./WordcloudContainer.vue?vue&type=template&id=234306ca&scoped=true"
import script from "./WordcloudContainer.vue?vue&type=script&lang=ts"
export * from "./WordcloudContainer.vue?vue&type=script&lang=ts"
import style0 from "./WordcloudContainer.vue?vue&type=style&index=0&id=234306ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234306ca",
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/wordcloud.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fviews%2FWordcloudContainer.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports